import { render } from "./GameImageEraser.vue?vue&type=template&id=70b9e11e&scoped=true"
import script from "./GameImageEraser.vue?vue&type=script&lang=js"
export * from "./GameImageEraser.vue?vue&type=script&lang=js"

import "./GameImageEraser.vue?vue&type=style&index=0&id=70b9e11e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b9e11e"],['__file',"src/vue/components/GameImageEraser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70b9e11e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70b9e11e', __exports__)) {
    api.reload('70b9e11e', __exports__)
  }
  
  module.hot.accept("./GameImageEraser.vue?vue&type=template&id=70b9e11e&scoped=true", () => {
    api.rerender('70b9e11e', render)
  })

}


export default __exports__